import { cn } from "../../lib";
import { CheckIcon } from "lucide-react";
import React, { FC } from "react";

interface StepperStep {
	label: string;
	isCompleted: boolean;
}

interface ProgressStepperProps {
	steps: StepperStep[];
	currentStep: number;
}

export const ProgressStepper: FC<ProgressStepperProps> = ({
	steps,
	currentStep,
}) => {
	return (
		<div className="flex items-center justify-center mx-auto">
			{steps.map((step, index) => (
				<React.Fragment key={index}>
					<div
						className={cn(`flex items-center p-1 font-semibold text-gray-400`, {
							"text-gray-700": step.isCompleted,
							"text-gray-900": currentStep === index + 1,
						})}
					>
						<div
							className={cn(
								`flex items-center justify-center rounded-full bg-gray-400 text-white w-6 h-6 font-bold text-xs`,
								{
									"bg-emerald-600 text-white": step.isCompleted,
								},
								{
									"bg-gray-900 text-white": currentStep === index + 1,
								},
							)}
						>
							{step.isCompleted ? <CheckIcon className="w-4 h-4" /> : index + 1}
						</div>
						<span className="ml-2">{step.label}</span>
					</div>
					{index < steps.length - 1 && (
						<div
							className={`flex-none w-8 border-t-2 ${
								currentStep > index + 1 || step.isCompleted
									? "border-gray-900"
									: "border-gray-400"
							} mx-2`}
						></div>
					)}
				</React.Fragment>
			))}
		</div>
	);
};
